import { request, seg } from "./http";
import type { Stream, StreamEvent, StreamInput, StreamPatch, StreamRun } from "./types";

export const streamsApi = {
  list: (workspaceId: string, signal?: AbortSignal) =>
    request<{ streams: Stream[]; usage: { activeStreams: number; activeStreamLimit: number } }>(
      "GET", `/v1/workspaces/${seg(workspaceId)}/streams`, undefined, { signal }),
  get: (id: string, signal?: AbortSignal) => request<Stream>("GET", `/v1/streams/${seg(id)}`, undefined, { signal }),
  create: (workspaceId: string, input: StreamInput) => request<Stream>("POST", `/v1/workspaces/${seg(workspaceId)}/streams`, input),
  update: (id: string, patch: StreamPatch) => request<Stream>("PATCH", `/v1/streams/${seg(id)}`, patch),
  setPlaylist: (id: string, videoIds: string[]) => request<Stream>("PUT", `/v1/streams/${seg(id)}/playlist`, { videoIds }),
  remove: (id: string) => request<void>("DELETE", `/v1/streams/${seg(id)}`),
  start: (id: string) => request<Stream>("POST", `/v1/streams/${seg(id)}/start`, {}),
  stop: (id: string) => request<Stream>("POST", `/v1/streams/${seg(id)}/stop`, {}),

  events: (id: string, opts: { limit?: number; before?: number } = {}, signal?: AbortSignal) => {
    const q = new URLSearchParams({ limit: String(opts.limit ?? 20) });
    if (opts.before) q.set("before", String(opts.before));
    return request<{ events: StreamEvent[]; nextBefore: number | null }>("GET", `/v1/streams/${seg(id)}/events?${q}`, undefined, { signal });
  },
  runs: (id: string, limit = 10, signal?: AbortSignal) =>
    request<{ runs: StreamRun[] }>("GET", `/v1/streams/${seg(id)}/runs?limit=${limit}`, undefined, { signal }).then((r) => r.runs),
};
